export const toDict = (arr, key) => {
  if (arr) {
    if (key && key.length > 0) return Object.assign({}, ...arr.map((x) => ({ [x[key]]: x })));
    else return Object.assign({}, ...arr.map((x) => ({ [x]: x })));
  } else return {};
};

// very slow
//export const toDict = (arr, key) => arr.reduce((a, x) => ({ ...a, [x[key]]: x }), {});
